import React, { useMemo } from 'react';
import { translate } from '../../../services/translate';
import FilterDropdown from '../../../components/Filter/components/FilterDropdown';
import { UseFormReturn } from 'react-hook-form';
import FormDropDownPicker from '../../../components/FormDropDownPicker';

type Props = {
    zIndex: number;
    single?: boolean;
    removeManual?: boolean;
} & ({
    form?: undefined;
    fieldName?: undefined;
    customValidations?: undefined;
    pattern?: undefined;
    value: (TriggerType | 'manual')[];
    setValue: React.Dispatch<React.SetStateAction<(TriggerType | 'manual')[]>>;
} | {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    form: UseFormReturn<any, any, any>;
    fieldName: string;
    value?: undefined;
    setValue?: undefined;
});

function TypeDropdown({ value, setValue, zIndex, single, removeManual = false, form, fieldName }: Props) {
    const items = useMemo(() => [
        'face_detected',
        'missing_face_detected',
        'plate_detected',
        'plate_detected_by_mobile_agent',
        'plate_detected_by_citizen_app',
        'irregular_vehicle',
        'clone_suspect',
        'illegal_debris',
        'area_invasion',
        'mp_plate_detected',
        'mp_mobile_agent_plate_detected',
        'mp_face_detected',
        'alarm_center',
        'manual',
        'guardian_app',
        'school_app',
        'sigrc',
        'cortex_plate_detected',
        'scenechangedetection'
    ].filter(triggerType => !(removeManual && triggerType === 'manual'))
        .map(triggerType => {
            return { label: translate(triggerType), value: triggerType };
        }), [removeManual]);

    if (form && fieldName) {
        return <FormDropDownPicker
            label={translate('integrationType')}
            items={items}
            fieldName={fieldName}
            form={form}
            multiple={true}
            mode='BADGE'
            zIndex={zIndex}
        />;
    } else if (value !== undefined && setValue !== undefined) {
        return (
            <FilterDropdown
                label={translate('integrationType')}
                items={items}
                multiple={true}
                mode='BADGE'
                setValue={setValue}
                onChangeValue={(values) => {
                    if (single && values && values.length > 1) {
                        setValue([values[values.length - 1] as TriggerType | 'manual']);
                    }
                }}
                value={value}
                zIndex={zIndex}
            />
        );
    }

}

export default TypeDropdown;
